import React, { useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { 
  Box,
  Select,
  MenuItem,
  FormControl,
  Typography
} from '@mui/material';

export const SkinNode = ({ data, selected, id }) => {
  const handleChange = useCallback((event) => {
    event.stopPropagation();
    data.onChange?.(event.target.value);
  }, [data]);

  const skinTypes = ['AnalPlug', 'Stack', 'Dildo', 'MistressDildo'];

  return (
    <div className="react-flow__node-default" style={{ minWidth: 250 }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <Typography variant="body2">Skin</Typography>
      </div>

      <Box sx={{ 
        padding: 2, 
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}>
        <FormControl size="small" className="nodrag">
          <Select
            value={data.value || 'AnalPlug'}
            onChange={handleChange}
            onMouseDown={e => e.stopPropagation()}
            displayEmpty
          >
            {skinTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="bought"
        style={{
          right: 0,
          top: 20,
          transform: 'translateY(-50%)'
        }}
      />
      <div style={{
        position: 'absolute',
        right: 25,
        top: 15,
        transform: 'translateY(-50%)',
        fontSize: '12px',
        color: '#666'
      }}>
        bought
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="declined"
        style={{
          right: 0,
          top: 40,
          transform: 'translateY(-50%)'
        }}
      />
      <div style={{
        position: 'absolute',
        right: 25,
        top: 35,
        transform: 'translateY(-50%)',
        fontSize: '12px',
        color: '#666'
      }}>
        declined
      </div>
    </div>
  );
};
